import { useEffect, useState } from 'react'

export default function usePaginator(call, data) {

  const [pagerLoading , setPagerLoading] = useState(true);
  const [pagerData    , setPagerData]    = useState([]);
  const [pagerHasMore , setPagerHasMore] = useState(false);

  useEffect(()=> {

    setPagerLoading(true)

    call(data).then((res)=> {
      setPagerLoading(false);
      setPagerData(res);
      setPagerHasMore(res.length > 0);
    });
  }, Object.values(data));

  return { pagerLoading, pagerData, pagerHasMore };
}
